import React, {useEffect,  useState} from "react";
import {
    createClickableLink
} from "../../../../components/common/datatable/DataTableUtils";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {SearchInputWrapper} from "../../../../components/common/datatable/filter/SearchInputWrapper";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {useSearchCodeQuery} from "../codeApi";
import IconButton from "../../../../components/common/form/IconButton";
import {FaPlus} from "react-icons/fa6";
import {useNavigate} from "react-router-dom";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";

const Code = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Codes");

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Codes", url: ""}]
    )
    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Codes';
    }, []);

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            visibility: {hasShowSetting: false},
            cell: (props: any) => {
                let path = "/codes/" + props.row.original.id;
                return createClickableLink(path, props.row.original.name, userSetting, false, "", ["CODES-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."}
                                                     name={"name"} accessor={"name"}/>,
                overrideFilterLabel: "Name.",
                overrideFilterAccessor: "name"
            }]
        },
        {
            label: "Code", accessor: "code",

        },
    ]

    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs}/>
            </div>


            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchCodeQuery,
                    exportAction: null
                }}
                buttonOptions={{
                    addButton:
                        {
                            button: <IconButton
                                icon={<FaPlus/>}
                                hasBackground={true}
                                onClick={() => {
                                    navigate("/codes/create")
                                }}
                                title={"Add Code"}
                            />,
                            permissions: ["CODES-C"]
                        },
                }}
                userSettingGroup={"Codes"}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                basePermission={"CODES"}
            />

        </div>

    );
};
export default Code;
